var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0806 11.8669H13.0806H11.0806H5.08057C4.81535 11.8669 4.561 11.9722 4.37346 12.1598C4.18592 12.3473 4.08057 12.6017 4.08057 12.8669C4.08057 13.1321 4.18592 13.3865 4.37346 13.574C4.561 13.7615 4.81535 13.8669 5.08057 13.8669H11.0806C11.0806 13.8669 12.2995 13.8669 13.0806 13.8669C15.4237 13.8669 19.0806 13.8669 19.0806 13.8669C19.3458 13.8669 19.6001 13.7615 19.7877 13.574C19.9752 13.3865 20.0806 13.1321 20.0806 12.8669C20.0806 12.6017 19.9752 12.3473 19.7877 12.1598C19.6001 11.9722 19.3458 11.8669 19.0806 11.8669Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.4216055e735dff90c79fff0b688e93a4.svg";
export { ForwardRef as ReactComponent };